/* tslint:disable */
/* eslint-disable */
/**
 * Oasis Nexus API V1
 * An API for accessing indexed data from the Oasis Network.  <!-- Acts as a separator after search in sidebar --> # Endpoints 
 *
 * The version of the OpenAPI document: 0.1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import {
    Account,
    AccountFromJSON,
    AccountFromJSONTyped,
    AccountToJSON,
    AccountListAllOf,
    AccountListAllOfFromJSON,
    AccountListAllOfFromJSONTyped,
    AccountListAllOfToJSON,
    List,
    ListFromJSON,
    ListFromJSONTyped,
    ListToJSON,
} from './';

/**
 * 
 * @export
 * @interface AccountList
 */
export interface AccountList {
    /**
     * The total number of records that match the query, i.e. the number of records
     * the query would return with limit=infinity.
     * @type {number}
     * @memberof AccountList
     */
    total_count: number;
    /**
     * Whether total_count is clipped for performance reasons.
     * @type {boolean}
     * @memberof AccountList
     */
    is_total_count_clipped: boolean;
    /**
     * 
     * @type {Array<Account>}
     * @memberof AccountList
     */
    accounts: Array<Account>;
}

export function AccountListFromJSON(json: any): AccountList {
    return AccountListFromJSONTyped(json, false);
}

export function AccountListFromJSONTyped(json: any, ignoreDiscriminator: boolean): AccountList {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'total_count': json['total_count'],
        'is_total_count_clipped': json['is_total_count_clipped'],
        'accounts': ((json['accounts'] as Array<any>).map(AccountFromJSON)),
    };
}

export function AccountListToJSON(value?: AccountList | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'total_count': value.total_count,
        'is_total_count_clipped': value.is_total_count_clipped,
        'accounts': ((value.accounts as Array<any>).map(AccountToJSON)),
    };
}


